import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  formControlLabelWrapperWithAmount: {
    width: '100%',
    maxWidth: theme.spacing(51.5),
    paddingTop: theme.spacing(1),
  },

  container: {
    width: '100%',
    marginBottom: theme.spacing(1),
    alignItems: 'flex-start',

    '& .MuiTypography-root:not(.radioAmount)': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    '& .radioAmount': {
      color: theme.palette.neutral.light,
      paddingLeft: theme.spacing(1),
    },
  },

  divider: {
    marginTop: theme.spacing(1),
  },
}))

export default useStyles
